import { RSAA } from 'redux-api-middleware'
export default {
  RSAA,
}
